import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { defer, firstValueFrom, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { StorageService } from './auth/storage.service';
import { environment } from 'src/environments/environment';
import { APIENDPOINT } from './constant/api-end-points';
import { differenceInMinutes } from 'date-fns';

@Injectable()
export class LangLoader implements TranslateLoader {

    constructor(private http: HttpClient, private storage: StorageService = inject(StorageService)) { }

    getTranslation(lang: string): Observable<any> {
        return defer(() => this.getTranslationsByLang(lang));
    }

    async getTranslationsByLang(lang: string) {
        if (!this.storage.getStorage()) {
            await this.storage.init();
        }

        let translations = null;
        const lastSync = await this.storage.get('last_lang_sync') as Date|null;
        if (lastSync && differenceInMinutes(new Date, lastSync) < 5) {
            translations = await this.storage.get(lang);
        }

        if (translations) {
            return translations;
        } else {
            return await firstValueFrom(this.http.get(`${environment.baseUrl + APIENDPOINT.LANGUAGE.LOAD + lang}`)
            .pipe(
                tap(data => {
                    this.storage.set(lang, data);
                    this.storage.set('last_lang_sync', new Date);
                }),
                map(data => data)
            )); 
        }
    }
}